import { SpecificationConfigurationItem, SpecificationsLibrary } from '@grandvisionhq/fun-products'

export const commonSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.lensColor,
  SpecificationsLibrary.frameColor,
  SpecificationsLibrary.frameMaterial,
  SpecificationsLibrary.frameShape,
  SpecificationsLibrary.frameType,
  SpecificationsLibrary.gender,
  SpecificationsLibrary.roadworthiness,
]

export const accessorySpecifications: SpecificationConfigurationItem[] = [
  ...commonSpecifications,
  SpecificationsLibrary.erpID,
  SpecificationsLibrary.accessoryType,
  SpecificationsLibrary.accessoryColor,
  SpecificationsLibrary.material,
]
